import { createOtherSoftwareFoundation, type AppFactoryOptions } from '@othercommerce/foundation';
import { createOtherSoftwareAutoloader, StoreLayout } from '@storefront/components';
import type { StorefrontShared, Customer } from '@storefront/resources';
import { createGoogleTagManager, createCookieConsent } from '@storefront/storefront';
import { createUnitFormatter } from '@othercommerce/domain';
import { createSSRApp, h } from 'vue';

import '@storefront/styles/variables.scss';
import '@storefront/styles/globals.scss';
import '@theme/styles/main.scss';

export function createStorefront({ router, props }: AppFactoryOptions) {
  const app = createSSRApp({ render: () => h(router, props) });

  const appLocale = props.state.shared.appLocale;
  const appGoogleTags = props.state.shared.appGoogleTags;

  app.use(createOtherSoftwareAutoloader());
  app.use(createOtherSoftwareFoundation({ shared: props.state.shared, layout: StoreLayout }));
  app.use(createUnitFormatter(appLocale));
  app.use(createGoogleTagManager(appGoogleTags));
  app.use(createCookieConsent(appLocale));

  return app;
}


declare module '@othercommerce/foundation' {
  interface Authenticated extends Customer {
    // Custom authenticated customer properties should go there...
  }

  interface Shared extends StorefrontShared {
    // Custom shared state properties should go there...
  }
}
